import(/* webpackChunkName: "faqQuestion" */ "Feature/ContentElements/code/Styles/Faq/faqQuestion.scss");

window.am = window.am || {};

window.am.faqcopypage = new function () {
    var that = this;

    that.init = function () {
        var copyButtons = document.querySelectorAll('.faq-copypage__button');

        copyButtons.forEach(function(button) {
            button.addEventListener('click', that.onCopyClick);
        });
    };

    that.onCopyClick = function () {
        var textToCopy = this.parent().querySelector('input').value;
        navigator.clipboard.writeText(textToCopy);
    };

};

window.am.faqcopypage.init();